/* Diamond Studio — checkout-path helpers (2026-09-29)
   Bag (every page):
   1. Free diamond studs progress bar in the bag works again. The gift script only trusts a
      subtotal that says "USD"; the bag shows "$2,050.00", so it fell back to the generic text.
   2. The same option line is not listed twice on a bag item (e.g. "Gold Color: 14K White").
   Product page:
   3. Ring size carries over when switching carat weight, and "Use your size: US 6.5" offers the
      size the shopper last picked on another ring (one tap, never pre-selected silently).
   4. The make-an-offer explanation sits under the offer button as one short line, so the
      options lead straight into "Add to bag".
   5. "You save $793" next to the discount badge (follows the gold upgrade).
   6. Desktop only, once per session: leaving the page after 20 seconds shows a small
      "Name your price" card that opens the existing offer window.
   7. Phones: the bottom buy bar is one compact row (price, Best offer, Add to bag) and says
      "Select size" instead of wrapping "Choose your ring size" onto two lines.
   8. "Not sure of the size? Every ring has 60-day returns." under the ring size.
   9. Engraving preview: the typed words on a band in the chosen gold, as they are typed.
  10. "Current product price" (a label that said nothing) is hidden; the upgrade note stays. */
(() => {
  'use strict';
  if (window.DSCtaCRO) return;
  window.DSCtaCRO = true;
  const track = (event, extra) => { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({event}, extra || {})); };
  const store = {
    get(area, key) { try { return window[area].getItem(key); } catch (e) { return null; } },
    set(area, key, value) { try { window[area].setItem(key, value); } catch (e) { /* storage unavailable */ } }
  };
  function waitFor(test, done, timeoutMs) {
    const start = Date.now();
    (function tick() {
      let result = null;
      try { result = test(); } catch (e) { result = null; }
      if (result) { done(result); return; }
      if (Date.now() - start > (timeoutMs || 15000)) return;
      setTimeout(tick, 200);
    })();
  }
  const money = cents => {
    const cur = window.DS_PREVIEW_CONFIG?.priceCurrency || window.DS_CRO?.currency || 'USD';
    try { return new Intl.NumberFormat('en-US', {style: 'currency', currency: cur, minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2}).format(cents / 100); }
    catch (e) { return '$' + Math.round(cents / 100).toLocaleString('en-US'); }
  };
  const cents = text => {
    const n = parseFloat(String(text || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(n) ? Math.round(n * 100) : NaN;
  };

  /* ---------- 1 + 2. Bag ---------- */
  function fixBag(root) {
    const usd = (window.DS_CRO?.currency || 'USD') === 'USD';
    root.querySelectorAll('.cart-modal-totalprice, .cart-total__subtotal-price').forEach(el => {
      if (!usd || /USD/.test(el.textContent) || el.querySelector('.ds-cta-cur')) return;
      const tag = document.createElement('span');
      tag.className = 'ds-cta-cur';
      tag.textContent = ' USD';
      el.append(tag);
    });
    root.querySelectorAll('.ds-bag-details').forEach(details => {
      const seen = new Set();
      details.querySelectorAll(':scope > p').forEach(line => {
        const text = line.textContent.replace(/\s+/g, ' ').trim();
        if (!text) return;
        if (seen.has(text)) line.hidden = true;
        seen.add(text);
      });
    });
  }
  function watchBag() {
    const run = () => {
      const drawer = document.getElementById('ds-cart-drawer');
      if (drawer) fixBag(drawer);
      const page = document.getElementById('cart-form');
      if (page) fixBag(page);
      window.DSStudGiftCart?.refresh?.();
    };
    let queued = false;
    const queue = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; run(); }); } };
    run();
    new MutationObserver(records => {
      if (records.some(r => (r.target.nodeType === 1 ? r.target : r.target.parentElement)?.closest?.('#ds-cart-drawer, #cart-form'))) queue();
    }).observe(document.body, {childList: true, subtree: true, characterData: true});
    document.addEventListener('ds:bag-rendered', queue);
  }

  /* ---------- Product page ---------- */
  const isProduct = () => document.body.classList.contains('signature-product-page');
  const SIZE_KEY = 'ds-last-ring-size';

  function setSize(select, value) {
    select.value = value;
    select.dispatchEvent(new Event('input', {bubbles: true}));
    select.dispatchEvent(new Event('change', {bubbles: true}));
  }

  /* 3. Ring size: carry across carat weights, offer the last size used elsewhere */
  function ringSize() {
    waitFor(() => document.getElementById('ring-size'), select => {
      const has = value => [...select.options].some(o => o.value === value);
      select.addEventListener('change', () => {
        if (select.value) store.set('localStorage', SIZE_KEY, select.value);
        document.querySelector('.ds-cta-size-suggest')?.remove();
      });
      // Carat weight links carry ?size= (added below); apply it once the page has settled.
      let carried = '';
      try { carried = new URLSearchParams(location.search).get('size') || ''; } catch (e) { carried = ''; }
      setTimeout(() => {
        if (select.value) return;
        if (carried && has(carried)) { setSize(select, carried); return; }
        const last = store.get('localStorage', SIZE_KEY);
        if (!last || !has(last) || document.querySelector('.ds-cta-size-suggest')) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ds-cta-size-suggest';
        button.innerHTML = 'Use your size: <strong>US ' + last.replace(/[^0-9.]/g, '') + '</strong>';
        button.addEventListener('click', () => {
          setSize(select, last);
          button.remove();
          track('ds_pdp_size_suggest_used');
        });
        select.after(button);
      }, 900);
    });
    // Add the chosen size to carat weight links (runs before the link's own handler).
    document.addEventListener('click', event => {
      const link = event.target.closest?.('a[data-ds-pc-size]');
      const select = document.getElementById('ring-size');
      if (!link || !select || !select.value) return;
      try {
        const url = new URL(link.getAttribute('href'), location.origin);
        url.searchParams.set('size', select.value);
        link.setAttribute('href', url.pathname + url.search);
      } catch (e) { /* keep the link */ }
    }, true);
  }

  /* 4. Offer explanation as one line under the offer button */
  function offerNote() {
    waitFor(() => document.getElementById('best-offer-button') && document.querySelector('.ds-cro-offer-copy'), () => {
      const button = document.getElementById('best-offer-button');
      const long = document.querySelector('.ds-cro-offer-copy');
      if (document.querySelector('.ds-cta-offer-note')) return;
      const note = document.createElement('p');
      note.className = 'ds-cta-offer-note';
      note.textContent = 'Name your price. If the studio accepts, you check out at that price. No payment to send an offer.';
      button.after(note);
      long.classList.add('ds-cta-moved');
    });
  }

  /* 5. "You save $793" */
  function savings() {
    waitFor(() => document.querySelector('.a-price-row .ds-product-discount'), badge => {
      const row = badge.closest('.a-price-row');
      if (!row || row.querySelector('.ds-cta-save')) return;
      const tag = document.createElement('span');
      tag.className = 'ds-cta-save';
      tag.hidden = true;
      badge.after(tag);
      const update = () => {
        const price = cents(row.querySelector(':scope > strong')?.textContent);
        const was = cents(row.querySelector('#compare-price')?.textContent);
        const show = price > 0 && was > price;
        const text = show ? 'You save ' + money(was - price) : '';
        if (tag.textContent !== text) tag.textContent = text;
        if (tag.hidden === show) tag.hidden = !show;
      };
      update();
      new MutationObserver(update).observe(row, {childList: true, subtree: true, characterData: true});
    });
  }

  /* 6. Desktop exit-intent: invite an offer instead of losing the visit */
  function offerNudge() {
    const desktop = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 900px)').matches;
    if (!desktop || store.get('sessionStorage', 'ds-cta-offer-nudge')) return;
    const started = Date.now();
    let blocked = false;
    document.addEventListener('ds:cart-added', () => { blocked = true; });
    document.addEventListener('click', event => {
      if (event.target.closest?.('#best-offer-button, [data-pdp-action="offer"], #buy-actions .a-primary, .a-sticky-buy .a-primary')) blocked = true;
    }, true);
    const show = () => {
      const offer = document.getElementById('best-offer-button');
      if (blocked || !offer || offer.disabled || document.querySelector('dialog[open]') || document.querySelector('.ds-cta-nudge')) return;
      store.set('sessionStorage', 'ds-cta-offer-nudge', '1');
      document.removeEventListener('mouseout', onOut);
      const card = document.createElement('aside');
      card.className = 'ds-cta-nudge';
      card.setAttribute('role', 'dialog');
      card.setAttribute('aria-labelledby', 'ds-cta-nudge-title');
      card.innerHTML = '<button type="button" class="ds-cta-nudge__close" aria-label="Close">×</button>' +
        '<p class="ds-cta-nudge__eyebrow">Before you go</p>' +
        '<h2 class="ds-cta-nudge__title" id="ds-cta-nudge-title">Name your price for this piece.</h2>' +
        '<p class="ds-cta-nudge__body">Send the studio an offer. No payment to send it, and you’ll get the answer by email.</p>' +
        '<div class="ds-cta-nudge__actions"><button type="button" class="ds-cta-nudge__go">Make an offer</button><button type="button" class="ds-cta-nudge__later">Not now</button></div>';
      const close = () => { card.remove(); document.removeEventListener('keydown', onKey); };
      const onKey = event => { if (event.key === 'Escape') close(); };
      card.querySelector('.ds-cta-nudge__close').addEventListener('click', () => { close(); track('ds_offer_nudge_dismiss'); });
      card.querySelector('.ds-cta-nudge__later').addEventListener('click', () => { close(); track('ds_offer_nudge_dismiss'); });
      card.querySelector('.ds-cta-nudge__go').addEventListener('click', () => { close(); track('ds_offer_nudge_click'); offer.click(); });
      document.addEventListener('keydown', onKey);
      document.body.append(card);
      track('ds_offer_nudge_show');
    };
    const onOut = event => {
      if (event.relatedTarget || event.clientY > 0 || Date.now() - started < 20000) return;
      show();
    };
    document.addEventListener('mouseout', onOut);
  }

  /* 7. Phones: shorter label on the bottom bar's main button */
  function stickyLabel() {
    waitFor(() => document.querySelector('.a-sticky-buy .a-primary'), button => {
      const label = button.querySelector('#sticky-add-label') || button.querySelector('span');
      const SHORT = {'Choose your ring size': 'Select size', 'Choose your options': 'Select options'};
      const apply = () => {
        const short = SHORT[(label?.textContent || '').trim()];
        if (short) { if (button.dataset.dsShort !== short) button.dataset.dsShort = short; }
        else if (button.dataset.dsShort) delete button.dataset.dsShort;
      };
      apply();
      if (label) new MutationObserver(apply).observe(label, {childList: true, characterData: true, subtree: true});
    });
  }

  /* 8. Size reassurance */
  function sizeHelp() {
    waitFor(() => document.getElementById('ring-size'), select => {
      if (document.querySelector('.ds-cta-size-help')) return;
      const help = document.createElement('p');
      help.className = 'ds-cta-size-help';
      help.textContent = 'Not sure of the size? Every ring has 60-day returns.';
      (select.closest('.a-size') || select.parentElement).append(help);
    });
  }

  /* 9. Engraving preview */
  function engravingPreview() {
    waitFor(() => document.getElementById('ds-engraving-text'), field => {
      const section = document.getElementById('ds-engraving');
      if (!section || section.querySelector('.ds-cta-engrave')) return;
      const box = document.createElement('div');
      box.className = 'ds-cta-engrave';
      box.hidden = true;
      box.innerHTML = '<div class="ds-cta-engrave__band" aria-hidden="true"><span class="ds-cta-engrave__text"></span></div>' +
        '<p class="ds-cta-engrave__note">Preview for length and spacing. The studio sets the final lettering.</p>';
      (document.getElementById('ds-engraving-tally') || field).after(box);
      const text = box.querySelector('.ds-cta-engrave__text');
      const metal = () => {
        const gold = String(window.DS_APP_SELECTION?.gold || document.querySelector('#ds-options-mount input[name="image-swatches-1"]:checked')?.value || '').toLowerCase();
        return /rose/.test(gold) ? 'rose' : /yellow/.test(gold) ? 'yellow' : 'white';
      };
      const update = () => {
        const value = field.value.trim();
        box.hidden = !value;
        if (text.textContent !== value) text.textContent = value;
        box.dataset.metal = metal();
      };
      field.addEventListener('input', update);
      document.addEventListener('ds:app-options', update);
      document.addEventListener('ds:engraving', update);
      update();
    });
  }

  /* 10. Quiet the "Current product price" label */
  function quietCaption() {
    waitFor(() => document.getElementById('price-caption'), caption => {
      const apply = () => caption.classList.toggle('ds-cta-quiet', caption.textContent.trim() === 'Current product price');
      apply();
      new MutationObserver(apply).observe(caption, {childList: true, characterData: true, subtree: true});
    });
  }

  function init() {
    watchBag();
    if (!isProduct()) return;
    ringSize();
    offerNote();
    savings();
    offerNudge();
    stickyLabel();
    sizeHelp();
    engravingPreview();
    quietCaption();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
